module.exports = __webpack_public_path__ + "img/Slide6.84982754.png";